import React from "react";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import HomeIcon from "@mui/icons-material/Home";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import {
  COLORS,
  HOME,
  PRODUCT_VARIANTS,
  PRODUCTS,
  VENDORS,
  ROLES,
  USERS,
  PRODUCT_ADD,
  PRODUCT_EDIT,
  USERS_EDIT,
  USERS_ADD,
  SIZES,
  FABRICS,
  CATEGORIES,
  PURCHASE_ORDERS,
  PURCHASE_ORDERS_ADD,
  PURCHASE_ORDERS_EDIT,
  PLATFORMS,
  BILL_LIST,
  BILL_ADD_From_PO,
  EXPENSE_TYPE,
  CASH_BOOK,
  CASH_CREDIT_DEBIT,
  CHEQUE_BOOK,
  CHEQUE_CREDIT_DEBIT,
  SALES_INVOICE,
  SALES_INVOICE_ADD,
  BILL_VIEW,
  SALES_INVOICE_EDIT,
  LEDGER,
  PROFIT_LOSS,
  BALANCE_SHEET,
  INCOME_TYPE,
  BILL_ADD,
  SAMPLES,
  SAMPLES_ADD,
  SAMPLES_EDIT,
  AUDITS,
  AUDITS_ADD,
  AUDITS_EDIT,
  AUDITS_LIST,
  LOGS_URL,
  UNIT_ECONOMICS,
  ORDER_MANAGEMENT,
  ORDER_MANAGEMENT_IMPORT,
  ORDER_MANAGEMENT_LIST,
  ORDER_MANAGEMENT_STATISTICS,
  ORDER_MANAGEMENT_RETURN_PROCESS,
  ORDER_MANAGEMENT_RETURNS,
  ORDER_MANAGEMENT_PAYMENT_PROCESS,
  DEBIT_NOTE,
  DEBIT_NOTE_LIST,
  ORDER_MANAGEMENT_STATISTICS_LIST,
  ORDER_MANAGEMENT_MARKETING_EXPENSES,
  ORDER_MANAGEMENT_FINANCE_DASHBOARD,
  ORDER_MANAGEMENT_PAYOUT_BREAKDOWN,
  ATTENDANCE_QR,
  ORDER_MANAGEMENT_PRODUCT_REPORT,
  OUTSTANDING_REPORT,
  ORDER_MANAGEMENT_ORDER_HISTORY,
  ORDER_MANAGEMENT_PAYMENT_MARKETING_EXPENSES_HISTORY,
  MYNTRA,
  MYNTRA_IMPORT,
  MYNTRA_ORDERS_LIST,
  MYNTRA_RETURNS,
  MYNTRA_PAYMENTS,
  MYNTRA_PRODUCT_REPORT,
  MYNTRA_STATISTICS,
  MYNTRA_STATISTICS_LIST,
  MYNTRA_FINANCE_DASHBOARD,
  MYNTRA_RETURN_REASON_ANALYSIS,
  ORDER_MANAGEMENT_RETURN_REASON_ANALYSIS,
  FLIPKART,
  FLIPKART_IMPORT,
  FLIPKART_ORDERS_LIST,
  FLIPKART_PAYMENTS,
  FLIPKART_STATISTICS,
  FLIPKART_STATISTICS_LIST,
  FLIPKART_PRODUCT_REPORT,
  FLIPKART_FINANCE_DASHBOARD,
  INVENTORY_MANAGEMENT,
  APP_SALES_REPORT,
  ORDER_LABEL_IMPORT,
} from "app/routes/constant";
import { Icon } from "@iconify/react";
import {
  Category,
  ColorLens,
  CurrencyRupee,
  FormatListNumbered,
  IntegrationInstructions,
  ListAlt,
  LocalAtm,
  Lock,
  Paid,
  Straighten,
} from "@mui/icons-material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import HailIcon from "@mui/icons-material/Hail";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CategoryIcon from '@mui/icons-material/Category';

const menus = [
  {
    label: "Dashboard",
    type: "section",
    children: [
      {
        uri: HOME,
        label: "Dashboard",
        type: "nav-item",
        icon: <HomeIcon sx={{ fontSize: 20 }} />,
        permission: "All",
      },
    ],
  },
  {
    label: "E-Commerce",
    type: "section",
    children: [
      // {
      //   uri: MEESHO,
      //   label: "Meesho",
      //   type: "nav-item",
      //   isActiveUri: [
      //     MEESHO,
      //     MEESHO_DASHBOARD,
      //     MEESHO_BULK_IMPORT,
      //     MEESHO_PAYMENT_IMPORT,
      //     MEESHO_ORDERS_LIST,
      //     MEESHO_RTO,
      //     MEESHO_PAYMENT,
      //     MEESHO_REPORT,
      //   ],
      //   icon: (
      //     <img
      //       style={{ width: "22px" }}
      //       src={`${ASSET_IMAGES}/meesho.svg`}
      //       alt="Jumbo React"
      //     />
      //   ),
      //   permission: "All",
      // },
      {
        uri: FLIPKART,
        label: "Flipkart",
        type: "nav-item",
        isActiveUri: [
          FLIPKART,
          FLIPKART_IMPORT,
          FLIPKART_ORDERS_LIST,
          FLIPKART_PAYMENTS,
          FLIPKART_STATISTICS,
          FLIPKART_STATISTICS_LIST,
          FLIPKART_PRODUCT_REPORT,
          FLIPKART_FINANCE_DASHBOARD,
        ],
        icon: <Icon icon="simple-icons:flipkart" width="22" height="22" />,
        permission: [
          "flipkart-import",
          "flipkart-order-list",
          "flipkart-payment-list",
          "flipkart-product-report",
          "flipkart-statistics",
          "flipkart-finance-dashboard",
        ],
      },
      {
        uri: ORDER_MANAGEMENT,
        label: "Meesho",
        type: "nav-item",
        isActiveUri: [
          ORDER_MANAGEMENT,
          ORDER_MANAGEMENT_IMPORT,
          ORDER_MANAGEMENT_LIST,
          ORDER_MANAGEMENT_STATISTICS,
          ORDER_MANAGEMENT_RETURN_PROCESS,
          ORDER_MANAGEMENT_RETURNS,
          ORDER_MANAGEMENT_PAYMENT_PROCESS,
          ORDER_MANAGEMENT_STATISTICS_LIST,
          ORDER_MANAGEMENT_MARKETING_EXPENSES,
          ORDER_MANAGEMENT_FINANCE_DASHBOARD,
          ORDER_MANAGEMENT_PAYOUT_BREAKDOWN,
          ORDER_MANAGEMENT_PRODUCT_REPORT,
          ORDER_MANAGEMENT_ORDER_HISTORY,
          ORDER_MANAGEMENT_PAYMENT_MARKETING_EXPENSES_HISTORY,
          ORDER_MANAGEMENT_RETURN_REASON_ANALYSIS,
        ],
        icon: (
          <img
            style={{ width: "22px" }}
            src={`${ASSET_IMAGES}/meesho.svg`}
            alt="Jumbo React"
          />
        ),
        permission: [
          "import-meesho-files",
          "order-list",
          "return-list",
          "meesho-statistics",
          "meesho-payment-list",
          "meesho-ads-list",
          "meesho-finance-dashboard",
          "meesho-payout-breakdown",
          "meesho-product-report",
          "meesho-return-reason",
        ],
      },
      {
        uri: MYNTRA,
        label: "Myntra",
        type: "nav-item",
        isActiveUri: [
          MYNTRA,
          MYNTRA_IMPORT,
          MYNTRA_ORDERS_LIST,
          MYNTRA_RETURNS,
          MYNTRA_PAYMENTS,
          MYNTRA_PRODUCT_REPORT,
          MYNTRA_STATISTICS,
          MYNTRA_STATISTICS_LIST,
          MYNTRA_FINANCE_DASHBOARD,
          MYNTRA_RETURN_REASON_ANALYSIS,
        ],
        icon: (
          <img
            style={{ width: "22px" }}
            src={`${ASSET_IMAGES}/myntra-logo.svg`}
            alt="Jumbo React"
          />
        ),
        permission: [
          "myntra-import",
          "myntra-order-list",
          "myntra-return-list",
          "myntra-payment-list",
          "myntra-product-report",
          "myntra-statistics",
          "myntra-finance-dashboard",
          "myntra-marketing-expenses",
        ],
      },
      {
        uri: UNIT_ECONOMICS,
        label: "UE Calculator",
        type: "nav-item",
        icon: <CalculateIcon sx={{ fontSize: 22 }} />,
        permission: "ue-calculator",
      },
      {
        uri: APP_SALES_REPORT,
        label: "App Sales Report",
        type: "nav-item",
        icon: <AssessmentIcon sx={{ fontSize: 22 }} />,
        permission: "app-sales-report",
      },
      {
        uri: ORDER_LABEL_IMPORT,
        label: "Label PDF Import",
        type: "nav-item",
        icon: <PictureAsPdfIcon sx={{ fontSize: 22 }} />,
        permission: "order-label-list",
      },
    ],
  },
  {
    label: "Production",
    type: "section",
    children: [
      {
        uri: INVENTORY_MANAGEMENT,
        label: "Inventory Management",
        type: "nav-item",
        permission: "inventory-list",
        icon: <CategoryIcon sx={{ fontSize: 22 }} />,
      },
      {
        uri: FABRICS,
        label: "Fabrics",
        type: "nav-item",
        permission: "list-fabric",
        icon: <Icon icon="game-icons:rolled-cloth" width="22" height="22" />,
      },
      {
        uri: PRODUCTS,
        label: "Product Manager",
        type: "nav-item",
        icon: (
          <Icon icon="fluent-mdl2:product-variant" width="22" height="22" />
        ),
        isActiveUri: [PRODUCTS, PRODUCT_ADD, PRODUCT_EDIT, PRODUCT_VARIANTS],
        permission: "list-product",
      },
      {
        uri: PURCHASE_ORDERS,
        isActiveUri: [
          PURCHASE_ORDERS,
          PURCHASE_ORDERS_ADD,
          PURCHASE_ORDERS_EDIT,
        ],
        icon: <Icon icon="bxs:purchase-tag" width="22" height="22" />,
        label: "PO (Purchase Order)",
        type: "nav-item",
        permission: "list-purchase-order",
      },
      {
        uri: BILL_LIST,
        isActiveUri: [
          BILL_LIST,
          BILL_ADD_From_PO,
          BILL_VIEW,
          BILL_ADD,
          DEBIT_NOTE,
          DEBIT_NOTE_LIST,
        ],
        label: "Bills / Purchase",
        type: "nav-item",
        permission: "list-bill",
        icon: <Icon icon="hugeicons:invoice" width="22" height="22" />,
      },
      {
        uri: SALES_INVOICE,
        isActiveUri: [SALES_INVOICE, SALES_INVOICE_ADD, SALES_INVOICE_EDIT],
        label: "Invoices / Sales",
        type: "nav-item",
        permission: "list-invoice",
        icon: <Icon icon="iconamoon:invoice-light" width="22" height="22" />,
      },
      {
        uri: SAMPLES,
        isActiveUri: [SAMPLES, SAMPLES_ADD, SAMPLES_EDIT],
        label: "Sample Management",
        type: "nav-item",
        permission: "list-sample",
        icon: (
          <Icon
            icon="carbon:ibm-data-product-exchange"
            width="22"
            height="22"
          />
        ),
      },
      {
        uri: AUDITS,
        isActiveUri: [AUDITS, AUDITS_ADD, AUDITS_EDIT, AUDITS_LIST],
        label: "Audit",
        type: "nav-item",
        permission: "list-audit",
        icon: <Icon icon="hugeicons:audit-02" width="24" height="24" />,
      },
    ],
  },
  {
    label: "accounting",
    type: "section",
    children: [
      {
        uri: CASH_BOOK,
        label: "Cash Book",
        type: "nav-item",
        permission: "entry-book-list",
        isActiveUri: [CASH_BOOK, CASH_CREDIT_DEBIT],
        icon: <Paid sx={{ fontSize: 20 }} />,
      },
      {
        uri: CHEQUE_BOOK,
        label: "Cheque Book",
        type: "nav-item",
        permission: "entry-book-list",
        isActiveUri: [CHEQUE_BOOK, CHEQUE_CREDIT_DEBIT],
        icon: <LocalAtm sx={{ fontSize: 20 }} />,
      },
      {
        uri: LEDGER,
        label: "Ledger",
        type: "nav-item",
        icon: <LibraryBooksIcon sx={{ fontSize: 20 }} />,
        permission: "report-ledger",
      },
      {
        uri: PROFIT_LOSS,
        label: "Profit & Loss",
        type: "nav-item",
        icon: <CurrencyRupee sx={{ fontSize: 20 }} />,
        permission: "report-profit-loss",
      },
      {
        uri: BALANCE_SHEET,
        label: "Balance sheet",
        type: "nav-item",
        icon: <ListAlt sx={{ fontSize: 20 }} />,
        permission: "report-balance-sheet",
      },
      {
        uri: OUTSTANDING_REPORT,
        label: "Payment Report",
        type: "nav-item",
        icon: <AssessmentIcon sx={{ fontSize: 20 }} />,
        permission: "report-paymnet-report",
      },
    ],
  },
  {
    label: "Settings",
    type: "section",
    children: [
      {
        uri: ROLES,
        label: "Roles & Permissions",
        type: "nav-item",
        permission: "role-list",
        icon: <Lock sx={{ fontSize: 20 }} />,
      },
      {
        uri: USERS,
        label: "Users",
        type: "nav-item",
        isActiveUri: [USERS, USERS_ADD, USERS_EDIT],
        icon: <SupervisedUserCircleIcon sx={{ fontSize: 20 }} />,
        permission: "user-list",
      },
      {
        uri: COLORS,
        label: "Colors",
        type: "nav-item",
        permission: "list-color",
        icon: <ColorLens sx={{ fontSize: 20 }} />,
      },
      {
        uri: SIZES,
        label: "Sizes",
        type: "nav-item",
        permission: "list-size",
        icon: <Straighten sx={{ fontSize: 20 }} />,
      },
      {
        uri: CATEGORIES,
        label: "Categories",
        type: "nav-item",
        permission: "category-list",
        icon: <Category sx={{ fontSize: 20 }} />,
      },
      {
        uri: PLATFORMS,
        label: "Platforms",
        type: "nav-item",
        permission: "list-platform",
        icon: <IntegrationInstructions sx={{ fontSize: 20 }} />,
      },
      {
        uri: VENDORS,
        label: "Vendor / Party",
        type: "nav-item",
        permission: "list-vendor",
        icon: <SupervisedUserCircleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: EXPENSE_TYPE,
        label: "Expense Type",
        type: "nav-item",
        permission: "list-expense-type",
        icon: <FormatListNumbered sx={{ fontSize: 20 }} />,
      },
      {
        uri: INCOME_TYPE,
        label: "Income Type",
        type: "nav-item",
        permission: "list-income-type",
        icon: <FormatListNumbered sx={{ fontSize: 20 }} />,
      },
      {
        uri: ATTENDANCE_QR,
        label: "Attendance",
        type: "nav-item",
        permission: "attendance-list",
        icon: <HailIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "Logs",
    type: "section",
    children: [
      {
        uri: LOGS_URL,
        label: "Logs",
        type: "nav-item",
        icon: <Icon icon="tabler:logs" width="20" height="20" />,
        permission: "list-log",
      },
    ],
  },
];

export default menus;
